"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.extensionKit = extensionKit;
exports.mergeKitOptions = mergeKitOptions;
const core_1 = require("@tiptap/core");
function extensionKit(name, fn) {
    return core_1.Extension.create({
        name,
        addExtensions() {
            const e = (extension, options) => {
                // ExtensionFactory -> ExtensionSpec is mostly intented as a wrapper to provide a comfortable typing
                return { extension, options: options ?? true };
            };
            const extensions = [];
            const entries = fn(e, this.options);
            for (const [key, _data] of Object.entries(entries)) {
                const data = _data;
                if (data?.extension === undefined)
                    continue;
                let options = mergeKitOptions(data.options, this.options[key]) ?? false;
                // "false" is indication that the extension should not be loaded at all
                if (options === false)
                    continue;
                // "true" is indication that the extension should be loaded with whatever options some parent loader provided
                if (options === true) {
                    if (typeof data.options === 'object') {
                        options = data.options;
                    }
                    else {
                        options = {};
                    }
                }
                extensions.push(data.extension.configure(options));
            }
            return extensions;
        }
    });
}
function mergeKitOptions(target, source) {
    if (typeof target === 'object' && typeof source === 'object') {
        const output = { ...target };
        Object.keys(source).forEach((key) => {
            const a = target[key];
            const b = source[key];
            if (typeof a === 'object' && typeof b === 'object') {
                output[key] = mergeKitOptions(a, b);
            }
            else {
                output[key] = b ?? a;
            }
        });
        return output;
    }
    return source ?? target;
}
//# sourceMappingURL=kit.js.map